import { IOrgUnitCodes, IOrgUnitRule } from './types';

interface ISurveyScopeInfo {
  surveyType?: number;
  surveyObject?: number;
  surveyForm?: number;
}

/**
 * Tính năng thành viên theo đơn vị + khóa chỉnh sửa chỉ áp dụng cho
 * Khảo sát thường (1) + đối tượng Nhân viên (1) + hình thức Đăng nhập (2).
 */
export const isOrgUnitMemberSurvey = (info?: ISurveyScopeInfo | null) =>
  !!info && info.surveyType === 1 && info.surveyObject === 1 && info.surveyForm === 2;

/** So đơn vị theo bộ mã các cấp tổ chức, không theo `id` */
export const orgUnitKey = (u: IOrgUnitCodes) =>
  [u.regionID, u.unitID, u.departmentID, u.divisionID, u.restaurantID]
    .map((x) => x ?? '')
    .join('|');

const LEVEL_FIELDS: (keyof IOrgUnitCodes)[] = [
  'regionID',
  'unitID',
  'departmentID',
  'divisionID',
  'restaurantID',
];

/** `child` là đơn vị cấp con (nằm trong) của `parent` — orgLevel 1..5 ứng với 5 cột mã */
export const containsOrgUnit = (parent: IOrgUnitRule, child: IOrgUnitRule) =>
  child.orgLevel > parent.orgLevel &&
  LEVEL_FIELDS.slice(0, parent.orgLevel).every(
    (field) => (parent[field] ?? null) === (child[field] ?? null)
  );

export const uniqueByOrgKey = (units: IOrgUnitRule[]) => {
  const seen = new Set<string>();
  return units.filter((u) => {
    const key = orgUnitKey(u);
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};
